import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { PaymentProcessProvider } from "../contexts/PaymentProcessContext";
import { DialogProvider } from "../contexts/DialogContext";
import { TenantProvider } from "../contexts/TenantContext";

export const PaymentProcessComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <PaymentProcessProvider key={0} />,
        <TenantProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
